module.exports = __webpack_public_path__ + "media/mutter_1.1b_2.23c89636.mp4";